import { Button, Menu } from "semantic-ui-react";

import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const MarketingBar: React.FC = () => {
    const { user } = useAuth0();

    return (
        <>
            {user && (
                <Menu style={{ borderBottom: "0" }} stackable tabular>
                    <Menu.Menu position="right">
                        <Menu.Item style={{ padding: "10px" }}>
                            <Button
                                color="blue"
                                content="GRANTOR & BENEFICIARY RESOURCES"
                                href="https://lifeinsurancetrustco.com/grantors-beneficiaries/?utm_source=portal&utm_content=GBButton"
                                target="_blank"
                            />
                        </Menu.Item>
                        <Menu.Item style={{ padding: "10px" }}>
                            <Button
                                color="blue"
                                content="BLOG"
                                href="https://lifeinsurancetrustco.com/blog?utm_source=portal&utm_content=BlogButton"
                                target="_blank"
                            />
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            )}
        </>
    );
};

export default MarketingBar;
